import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18N } from 'commons';
import ContactPathsRow from './ContactPathsRow';
import MobileAppSection from './MobileAppSection';

function ContactPathsSection(props) {
  const {
    values,
    errors,
    setFieldError,
    touched,
    setFieldTouched,
    setFieldValue,
    contactPathError,
    setContactPathError,
    isNeedValidation,
    setIsNeedValidation,
    isMinContactPathNumShow,
    minContactPathNum,
    isAllFieldMandatory,
    contactPaths: contactPathsInProps,
    isEditMode,
    setIscallOutMsgShow
  } = props;

  let mobilePushPathObject = null;
  let customPushPathList = [];
  const paths = contactPathsInProps.filter((contactPath) => {
    if (contactPath.type === 'RECIP') {
      if (contactPath.value === 'yes') {
        return contactPath.expose && isEditMode;
      }

      if (contactPath.code === 'RECIP') {
        mobilePushPathObject = contactPath;
      } else {
        customPushPathList.push(contactPath)
      }
      return false;
    }
    return contactPath.expose;
  });
  const [mobilePushPath] = useState(mobilePushPathObject);


  const [contactPaths, setContactPaths] = useState(paths);
  const [isShowMobileApp] = useState(contactPathsInProps.some(({ type, code }) => type === 'RECIP' && code === 'RECIP'));

  useEffect(() => {
    setContactPaths(paths);
  }, [paths.length]);

  const updateContactPath = (path, index) => {
    contactPaths[index] = path;
    setContactPaths(contactPaths);
    setFieldValue('contactPaths', contactPaths);
  };

  const handleMoveUp = (path, index) => {
    contactPaths.splice(index - 1, 0, contactPaths.splice(index, 1)[0]);
    const updatedContactPaths = [...contactPaths];
    setContactPaths(updatedContactPaths);
    setFieldValue('contactPaths', updatedContactPaths);
  };

  const handleMoveDown = (index) => {
    contactPaths.splice(index + 1, 0, contactPaths.splice(index, 1)[0]);
    const updatedContactPaths = [...contactPaths];
    setContactPaths(updatedContactPaths);
    setFieldValue('contactPaths', updatedContactPaths);
  };

  const handleOnChange = (path, updatedValues, index) => {
    const newContactPathDetails = {
      ...path,
      ...updatedValues,
    };
    updateContactPath(newContactPathDetails, index);
  };

  return (
    <div>
      {isMinContactPathNumShow && (
        <div className="col-md-10 pl-0">
          <div
            id="minContactPath-error"
            className="text-danger"
            tabIndex={-1}
          >
            <I18N>
              {`new.registration.signup.create.contactpath.error, ${minContactPathNum}`}
            </I18N>
          </div>
        </div>
      )}
      {contactPaths.map((contactPath, index) => (
        <ContactPathsRow
          isAllFieldMandatory={isAllFieldMandatory}
          contactPath={contactPath}
          allContactPaths={contactPaths}
          key={`${contactPath.pathId}`}
          handleMoveUp={() => handleMoveUp(contactPath, index)}
          handleMoveDown={() => handleMoveDown(index)}
          onChange={updatedValues => handleOnChange(contactPath, updatedValues, index)}
          errors={errors}
          values={values}
          setFieldError={setFieldError}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          touched={touched}
          contactPathError={contactPathError}
          setContactPathError={setContactPathError}
          index={index}
          isNeedValidation={isNeedValidation}
          setIsNeedValidation={setIsNeedValidation}
          setIscallOutMsgShow={setIscallOutMsgShow}
        />
      ))}

      {
        customPushPathList.map((contactPath, index) => 
        <ContactPathsRow 
          isAllFieldMandatory={isAllFieldMandatory}
          contactPath={contactPath}
          allContactPaths={customPushPathList}
          key={`${contactPath.pathId}`}
          handleMoveUp={() => {}}
          handleMoveDown={() => {}}
          onChange={() => {}}
          errors={errors}
          values={values}
          setFieldError={setFieldError}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          touched={touched}
          contactPathError={contactPathError}
          setContactPathError={setContactPathError}
          index={contactPaths.length + index}
          isNeedValidation={isNeedValidation}
          setIsNeedValidation={setIsNeedValidation}
      />
        )
      }

      {
        mobilePushPath &&
          <ContactPathsRow
            isAllFieldMandatory={isAllFieldMandatory}
            contactPath={mobilePushPath}
            allContactPaths={[mobilePushPath]}
            key={`${mobilePushPath.pathId}`}
            handleMoveUp={() => {}}
            handleMoveDown={() => {}}
            onChange={() => {}}
            errors={errors}
            values={values}
            setFieldError={setFieldError}
            setFieldTouched={setFieldTouched}
            setFieldValue={setFieldValue}
            touched={touched}
            contactPathError={contactPathError}
            setContactPathError={setContactPathError}
            index={contactPaths.length + customPushPathList.length}
            isNeedValidation={isNeedValidation}
            setIsNeedValidation={setIsNeedValidation}
          />
      }
      {isShowMobileApp && <MobileAppSection />}
    </div>
  );
}

ContactPathsSection.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  contactPaths: PropTypes.arrayOf(PropTypes.shape()),
  setFieldValue: PropTypes.func.isRequired,
  setFieldError: PropTypes.func.isRequired,
  errors: PropTypes.shape().isRequired,
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  contactPathError: PropTypes.shape().isRequired,
  setContactPathError: PropTypes.func.isRequired,
  isNeedValidation: PropTypes.bool.isRequired,
  setIsNeedValidation: PropTypes.func.isRequired,
  isMinContactPathNumShow: PropTypes.bool.isRequired,
  minContactPathNum: PropTypes.number,
  isAllFieldMandatory: PropTypes.bool.isRequired,
  setIscallOutMsgShow: PropTypes.func.isRequired,
};

ContactPathsSection.defaultProps = {
  contactPaths: [],
  minContactPathNum: 0,
};

export default ContactPathsSection;
